import React, { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Spinner, Stack } from "@bookingcom/bui-react";
import useSearchPaginationController from "./useSearchPagination.controller.js";
import { getSearchFetchStatus } from "../../../store/searchResults/selectors.js";
import flights_funnel_sr_auto_load_offers_mobile, { useFlightsFunnelSrAutoLoadOffersMobile } from "../../../utils/experiments/funnel/flights_funnel_sr_auto_load_offers_mobile.js";
export default function SearchPaginationAutoLoadMobile() {
    const fetchStatus = useSelector(getSearchFetchStatus);
    const { canRender, currentPage, totalPages, goToPage } = useSearchPaginationController();
    const { trackStages } = useFlightsFunnelSrAutoLoadOffersMobile();
    const ref = useRef(null);
    const loadNextPage = useCallback(() => {
        if (!canRender)
            return;
        if (currentPage >= totalPages)
            return;
        if (fetchStatus !== "success")
            return;
        goToPage(currentPage + 1, true, true);
    }, [currentPage, totalPages, goToPage, fetchStatus, canRender]);
    useEffect(() => {
        let timeoutId;
        const observer = new IntersectionObserver((e) => {
            if (!e?.[0]?.isIntersecting)
                return;
            trackStages();
            if (!flights_funnel_sr_auto_load_offers_mobile.trackWithDefaultStage())
                return;
            if (timeoutId)
                clearTimeout(timeoutId);
            timeoutId = setTimeout(() => loadNextPage(), 100);
        });
        if (ref?.current)
            observer.observe(ref.current);
        return () => {
            if (timeoutId)
                clearTimeout(timeoutId);
            observer.disconnect();
        };
    }, [ref, loadNextPage, trackStages]);
    if (!canRender)
        return null;
    return (React.createElement("div", { ref: ref }, fetchStatus === "loading" && !!flights_funnel_sr_auto_load_offers_mobile.trackWithDefaultStage() ? (React.createElement(Stack, { alignItems: "center" },
        React.createElement(Spinner, null))) : undefined));
}
